
import { useCallback } from 'react';
import { useEntitiesSearch } from './search/useEntitiesSearch';
import { usePagesSearch } from './search/usePagesSearch';
import { useSearchNavigation } from './search/useSearchNavigation';
import { SearchResult } from '@/types/search';

export type { SearchResult };

export const useGlobalSearch = () => {
  const { searchEntities } = useEntitiesSearch();
  const { searchPages } = usePagesSearch();
  const { handleResultClick: navigate } = useSearchNavigation();

  const search = useCallback((searchQuery: string): SearchResult[] => {
    if (!searchQuery || searchQuery.length < 2) {
      return [];
    }

    const entityResults = searchEntities(searchQuery);
    const pageResults = searchPages(searchQuery);
    
    return [...pageResults, ...entityResults];
  }, [searchEntities, searchPages]);

  const handleResultClick = useCallback((result: SearchResult) => {
    console.log('Result clicked:', result);
    navigate(result);
  }, [navigate]);

  return {
    search,
    handleResultClick
  };
};
